/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// taken directly from https://webostv.developer.lge.com/develop/code-samples/multi-sound/
// with alerts changed to Screen.logMessageToSentry

export default function SoundSource(context, urlList, callback) {
	this.context = context;
	this.urlList = urlList;
	this.onload = callback;
	this.bufferList = new Array();
	this.sound = new Array();
	this.soundBuf = new Array();
	this.loadCount = 0;
  
	this.load();
}

SoundSource.prototype.hasSoundLoaded = function(url) {
	return this.urlList.indexOf(url) >= 0;
};

SoundSource.prototype.loadBuffer = function(url, index) {
	// Load buffer asynchronously
	const request = new XMLHttpRequest();
	request.open('GET', url, true);
	request.responseType = 'arraybuffer';

	const loader = this;

	request.onload = function() {
		// Asynchronously decode the audio file data in request.response
		loader.context.decodeAudioData(
			request.response,
			function(buffer) {
				if (!buffer) {
					Screen.logMessageToSentry('error decoding file data: ' + url);
					return;
				}
				loader.bufferList[index] = buffer;
				loader.prepareSound(index);
				loader.sound[index] = null;
				if ((++loader.loadCount == loader.urlList.length) && (loader.onload != null))
					loader.onload(loader.bufferList);
			}    
		);
	};

	request.onerror = function() {
		Screen.logMessageToSentry('BufferLoader: XHR error');        
	};

	request.send();
};

SoundSource.prototype.prepareSound = function(index) {
	try {
		this.soundBuf[index] = this.context.createBufferSource();
		this.soundBuf[index].buffer = this.bufferList[index];
		this.soundBuf[index].connect(this.context.destination);
	}
	catch (ex) {
		Screen.logErrorToSentry(ex);
	}
};

SoundSource.prototype.load = function() {
	try {
		for (let i = 0; i < this.urlList.length; ++i) {
			this.loadBuffer(this.urlList[i], i);
		}
	}
	catch (ex) {
		Screen.logErrorToSentry(ex);
	}
};

SoundSource.prototype.start = function(url, onEnded) {
	try {
		const index = this.urlList.indexOf(url);
		if (index >= 0) {
			this.stop(index);
			const soundBuff = this.soundBuf[index];
			if (soundBuff) {
				soundBuff.onended = onEnded;
				soundBuff.start(0);
				this.sound[index] = soundBuff;
			} else {
				Screen.logMessageToSentry('Sound source not in the buffer!');
			}
			this.prepareSound(index);
		}
	} catch (ex) {
		Screen.logErrorToSentry(ex);
	}
};

SoundSource.prototype.stop = function(index) {
	try {
		const sound = this.sound[index];
		if (sound == null)
			return;

		if ((sound.playbackState == sound.PLAYING_STATE) || (sound.playbackState == sound.SCHEDULED_STATE)) {
			sound.stop(0);
			this.sound[index] = null;
		}
	} catch (ex) {
		Screen.logErrorToSentry(ex);
	}
};

SoundSource.prototype.stopAll = function() {
	try {
		let sound;
		let index;
		for (index = 0; index < this.sound.length; index++)
		{
			if ((sound = this.sound[index]) != null)
				this.stop(index);
		}
	} catch (ex) {
		Screen.logErrorToSentry(ex);
	}
};

SoundSource.prototype.clearEvents = function() {
	let sound;
	let index;
	for (index = 0; index < this.sound.length; index++)
	{
		if ((sound = this.sound[index]) != null)
			sound.onended = null;
	}
};

